import { render } from "./SubmittedDispositions.vue?vue&type=template&id=5c29160d&scoped=true"
import script from "./SubmittedDispositions.vue?vue&type=script&lang=js"
export * from "./SubmittedDispositions.vue?vue&type=script&lang=js"

import "../css/SubmittedDispositions.css?vue&type=style&index=0&id=5c29160d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c29160d"]])

export default __exports__